const defaults = require('./defaults');

module.exports = {
  ...defaults,
  mode: 'development',
  urlRoot: 'https://staging.ls-www.localsearch.cloud',
  serviceApiRoot: 'https://staging.services.lsapis.com.au',
  serviceGraphqlRoot: 'https://staging.services.lsapis.com.au/graphql',
  imageResizeRoot: 'https://dkw8fcvpqki80.cloudfront.net',
  logger: {
    ...defaults.logger,
    console: {
      level: 'error',
    },
  },
  recaptchaMinScore: 0,
};
